<template>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">Strain Gauge</h1>
            </div><!-- /.col -->
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                <li class="breadcrumb-item active">Strain Gauge</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <div class="content">
        <div class="container-fluid">

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Fecha</h5>

                  <div class="card-text">
                    <div class="row">
                      <div class="col-lg-12">
                        <datepicker v-model="fecha"></datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <template v-for="(chart,index) in charts">
            <div class="row" >
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{chart.data.label}}</h5>
                    <div class="card-text">
                      <scatterjs :chartData="chart.data" :options="options" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.row -->
          </template>

        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Scatterjs from '../components/Scatterjs'

export default {
  name: 'Gauge',
  components: { Datepicker, Scatterjs },
  data () {
    return {
      fecha: null,
      charts: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            id: 'deformacion',
            scaleLabel: {
              display: true,
              labelString: 'Deformación'
            },
            position: 'left'
          }, {
            id: 'temperatura',
            scaleLabel: {
              display: true,
              labelString: 'Temperatura'
            },
            position: 'right',
            ticks: {
              max: 65,
              min: 15,
              stepSize: 0
            }
          }],
          xAxes: [{
            type: 'time',
            scaleLabel: {
              display: true,
              labelString: 'Fecha'
            }
          }]
        }
      }
    }
  },
  mounted: function () {
    var obj = this
    this.$http.post(this.$store.state.apiurl + '/api-token-auth/', { username: 'admin', password: 'Josesin1' }).then(function (valx) {
      obj.urlconfig = {
        credentials: true,
        headers: { 'Authorization': 'Token ' + valx.body.token }
      }
      obj.fecha = Date.now()
    })
  },
  methods: {
    actualizar (fecha) {
      var obj = this
      var url = this.$store.state.apiurl + '/strain_gauge/' + fecha.getFullYear() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getDate() + '/30'
      this.$http.get(url).then((val) => {
        obj.charts = val.data
      })
    }
  },
  watch: {
    fecha: function (val, orig) {
      var dval = new Date(val)
      this.actualizar(dval)
    }
  },
  computed: {
  }
}
</script>
